import React, { Component } from 'react';
import _ from 'lodash';

import SimpleModal from '../SimpleModal';
import CampusStore from '../../stores/CampusStore';

export default class EditCampusPage extends Component {
  constructor(props){
    super(props);

    this.state = {
      campus: {
        code: this.props.campus.code,
        name: this.props.campus.name,
        url: this.props.campus.url
      }
    }

    this.handleSave = this.handleSave.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  onChange(){
    this.setState({
      campus: {
        code: this.refs.code.value,
        name: this.refs.name.value,
        url: this.refs.url.value
      }
    })
  }

  handleSave(event){
    event.preventDefault();

    CampusStore.save(this.props.campus.id, {
      campus: {
        code: this.state.campus.code,
        name: this.state.campus.name,
        url: this.state.campus.url
      }
    }).then(()=>{
      this.props.handleCloseAndReloadData();
    })
  }

  render(){
    return (
      <div>
        <SimpleModal 
          isOpen={true}
          title={'แก้ไข'}
          showSubmitButton={false}
          onClose={()=>this.props.onClose()}>
          
          <form onSubmit={this.handleSave}>

            <div className='row form-group'>
              <div className='col-2 text-right'>
                <label className='required'>รหัส:</label>
              </div>
              <div className='col-10'>
                <input 
                  type='text' 
                  ref='code'
                  value={this.state.campus.code || ''}
                  className='form-control form-control-sm'
                  onChange={this.onChange} />
              </div>
            </div>
            <div className='row form-group'>
              <div className='col-2 text-right'>
                <label className='required'>ชื่อ:</label>
              </div>
              <div className='col-10'>
                <input 
                  type='text' 
                  ref='name'
                  value={this.state.campus.name || ''}
                  className='form-control form-control-sm'
                  onChange={this.onChange} />
              </div>
            </div>
            <div className='row form-group'>
              <div className='col-2 text-right'>
                <label className='required'>URL:</label>
              </div>
              <div className='col-10'>
                <input 
                  type='text' 
                  ref='url'
                  value={this.state.campus.url || ''}
                  className='form-control form-control-sm'
                  onChange={this.onChange} />
              </div>
            </div>
            <div className="modal-footer row">
              <button type='submit' className="btn btn-primary pointer">บันทึก</button>
              <button type='button' className="btn btn-secondary pointer" onClick={()=>this.props.onClose()}>Close</button>
            </div>

          </form>

        </SimpleModal>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/settings/EditCampusPage.js